import React, { useState, useEffect } from "react";
import { Box, Button, IconButton, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import Header from "../../components/Header";
import DataGridCustomToolbar from "../../components/DataGridCustomToolbar";
import DeleteIcon from "@mui/icons-material/Delete";
import { deleteTransactionAction } from "../../redux/actions/transactionAction";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import axios from "axios";
import SendIcon from "@mui/icons-material/Send";
import { PictureAsPdf as PdfIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const Transactions = () => {
  const theme = useTheme();

  // values to be sent to the backend
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [sort, setSort] = useState({});
  const [search, setSearch] = useState("");

  const [users, setUsers] = useState([]);
  const [isDataFetched, setIsDataFetched] = useState(false);
  const [rowData, setRowData] = useState([]);

  const [dates, setDates] = useState({ fromDate: "", toDate: "" });

  const handleDateChange = (field) => (event) => {
    setDates({ ...dates, [field]: event.target.value });
  };

  const fetchData = async () => {
    try {
      const response = await axios.get("/user/userFullname");
      setUsers(response.data.profile);
      setIsDataFetched(true);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleOpen = () => {
    if (!isDataFetched) {
      fetchData();
    }
  };

  const dispatch = useDispatch();

  const [searchInput, setSearchInput] = useState("");
  // const { data, isLoading } = useGetTransactionsQuery({
  //   page,
  //   pageSize,
  //   sort: JSON.stringify(sort),
  //   search,
  // });

  let [filterData, setFilterData] = useState([]);
  const [filterSelected, setFilterSelected] = useState(false);

  const handleDelete = async (uid) => {
    try {
      const success = await dispatch(deleteTransactionAction(uid));
      if (success) {
        toast.success("Transaction deleted successfully");
        handleSubmit();
      } else {
        toast.error("Failed to delete transaction");
      }
    } catch (error) {
      console.error("Error deleting transaction:", error);
    }
  };

  const removeTransaction = (uid) => {
    Swal.fire({
      title: "Confirm Removal",
      text: "Are you sure you want to remove this ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, remove it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(uid);
      }
    });
  };
  const navigate = useNavigate();

  const [selectedValue, setSelectedValue] = useState("");

  const handleChange = (event, type) => {
    const value = event.target.value;
    if (value === "all") {
      setDates({ fromDate: "", toDate: "" });
      setFilterData({});
    } else {
      if (type === "fromDate" || type === "toDate") {
        setDates((prevDates) => ({
          ...prevDates,
          [type]: value,
        }));
      } else {
        setFilterData((prevFilters) => ({
          ...prevFilters,
          [type]: value,
        }));
      }
    }
  };
  // console.log(dates);
  const handleSubmit = async () => {
    try {
      const response = await axios.get("/transaction/list", {
        params: {
          ...filterData,
          fromDate: dates.fromDate,
          toDate: dates.toDate,
        },
      });
      setRowData(response.data.transactions);
      setFilterSelected(true);
      // console.log(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    handleSubmit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    {
      field: "fullname",
      headerName: "User",
      flex: 0.7,
      minWidth: 100,
    },
    {
      field: "paymentGateway",
      headerName: "Payment Gateway",
      flex: 0.5,
      minWidth: 100,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 0.6,
      minWidth: 100,
    },
    {
      field: "totalAmount",
      headerName: "Total Amount",
      flex: 0.7,
      minWidth: 100,
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      minWidth: 100,
      valueGetter: (params) => params.row.email,
    },
    {
      field: "createdAt",
      headerName: "Created",
      flex: 0.8,
      minWidth: 100,
    },
    {
      field: "updatedAt",
      headerName: "Updated",
      flex: 0.8,
      minWidth: 100,
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      disableColumnReorder: true,
      renderCell: (params) => (
        <div>
          <IconButton
            variant="contained"
            color="secondary"
            onClick={() => removeTransaction(params.row.uid)}
          >
            <DeleteIcon size="small" />
          </IconButton>
        </div>
      ),
    },
  ];

  return (
    <Box m="1.5rem 2.5rem">
      <ToastContainer />
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <Header title="TRANSACTIONS" />
      </Box>
      <FormControl variant="standard" sx={{ m: 2, minWidth: 200 }}>
        <InputLabel id="select-standard-label">user</InputLabel>
        <Select
          id="select-standard"
          onChange={(e) => handleChange(e, "userId")}
          onOpen={handleOpen}
          label="user"
        >
          <MenuItem value="all">All</MenuItem>
          {isDataFetched &&
            users.map((user) => (
              <MenuItem key={user.fullname} value={user._id}>
                {user.fullname}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
      <FormControl variant="standard" sx={{ m: 2, minWidth: 200 }}>
        <InputLabel id="select-standard-label">Email</InputLabel>
        <Select
          id="select-standard"
          onChange={(e) => handleChange(e, "email")}
          onOpen={handleOpen}
          label="Email"
        >
          <MenuItem value="all">All</MenuItem>
          {isDataFetched &&
            users.map((user) => (
              <MenuItem key={user._id} value={user.email}>
                {user.email}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
      <FormControl variant="standard" sx={{ m: 2, minWidth: 200 }}>
        <InputLabel id="select-standard-label">Mobile Number</InputLabel>
        <Select
          id="select-standard"
          onChange={(e) => handleChange(e, "mobileNumber")}
          onOpen={handleOpen}
          label="Mobile Number"
        >
          <MenuItem value="all">All</MenuItem>
          {isDataFetched &&
            users.map((user) => (
              <MenuItem key={user._id} value={user.mobileNumber}>
                {user.mobileNumber}
              </MenuItem>
            ))}
        </Select>
      </FormControl>

      {/* <FormControl variant="standard" sx={{ m: 2, minWidth: 200 }}>
        <InputLabel id="select-standard-label">Payment Gateway</InputLabel>
        <Select
          id="select-standard"
          onChange={(e) => handleChange(e, "paymentGateway")}
          label="Payment Gateway"
        >
          <MenuItem value="all">All</MenuItem>
          <MenuItem value="dpaisa">Dpaisa</MenuItem>
          <MenuItem value="esewa">Esewa</MenuItem>
          <MenuItem value="khalti">Khalti</MenuItem>
        </Select>
      </FormControl> */}

      {/* <FormControl variant="standard" sx={{ m: 2, minWidth: 200 }}>
        <InputLabel id="select-standard-label">Payment Status</InputLabel>
        <Select
          id="select-standard"
          onChange={(e) => handleChange(e, "paymentStatus")}
          label="Payment Status"
        >
          <MenuItem value="all">All</MenuItem>
          <MenuItem value="Completed">Completed</MenuItem>
          <MenuItem value="Not_Verified_yet">Not Verified</MenuItem>
          <MenuItem value="Pending">Pending</MenuItem>
          <MenuItem value="Failed">Failed</MenuItem>
        </Select>
      </FormControl> */}

      {/* <FormControl variant="standard" sx={{ m: 2, minWidth: 200 }}>
        <InputLabel id="select-standard-label">Expires in week</InputLabel>
        <Select
          id="select-standard"
          onChange={(e) => handleChange(e, "ExpiresInWeek")}
          label="Payment Gateway"
        >
          <MenuItem value="all">All</MenuItem>
          <MenuItem value={new Date().toISOString().split("T")[0]}>
            Expires in week
          </MenuItem>
        </Select>
      </FormControl> */}

      <FormControl variant="standard" sx={{ m: 2, minWidth: 200 }}>
        <div>
          <TextField
            id="from-date"
            label="From"
            type="date"
            value={dates.fromDate}
            onChange={(e) => handleChange(e, "fromDate")}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            id="to-date"
            label="To"
            type="date"
            value={dates.toDate}
            onChange={(e) => handleChange(e, "toDate")}
            InputLabelProps={{
              shrink: true,
            }}
            sx={{ marginLeft: 2 }}
          />
        </div>
      </FormControl>

      <FormControl variant="standard" sx={{ m: 2, minWidth: 100 }}>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          startIcon={<SendIcon />}
          onClick={handleSubmit}
        >
          Filter
        </Button>
      </FormControl>

      {filterSelected && (
        <Box
          height="80vh"
          // overflowX="auto"
          // position="relative"
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: theme.palette.background.alt,
              color: theme.palette.secondary[100],
              borderBottom: "none",
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: theme.palette.primary.success,
            },
            "& .MuiDataGrid-footerContainer": {
              backgroundColor: theme.palette.background.alt,
              color: theme.palette.secondary[100],
              borderTop: "none",
            },
            "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
              color: `${theme.palette.secondary[200]} !important`,
            },
            // "& .MuiDataGrid-root .MuiDataGrid-cell:nth-child(16)": {
            //   position: "sticky",
            //   right: 0,
            //   zIndex: 1,
            // },
          }}
        >
          <DataGrid
            // loading={isLoading || !data}
            getRowId={(row) => row._id}
            rows={rowData}
            columns={columns}
            autoHeight
            disableColumnMenu
            disableColumnSelector
            hideFooter
            // initialState={{
            //   pinnedColumns: { right: ["actions"] },
            // }}
            rowCount={(rowData && rowData.total) || 0}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            page={page}
            pageSize={pageSize}
            paginationMode="server"
            sortingMode="server"
            onPageChange={(newPage) => setPage(newPage)}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            onSortModelChange={(newSortModel) => setSort(...newSortModel)}
            components={{
              Toolbar: DataGridCustomToolbar,
            }}
            componentsProps={{
              toolbar: {
                searchInput,
                setSearchInput,
                setSearch,
                columns,
                rowData,
              },
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default Transactions;
